import React from 'react';

const style = {
  display: 'block',
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export function TruncatedText({ children }) {
  const text = children == null || children === '' ? '-' : String(children);

  // Only sets the tooltip when the text is actually cut off.
  const handleMouseEnter = (e) => {
    const el = e.currentTarget;
    if (el.scrollWidth > el.clientWidth) {
      el.setAttribute('title', text);
    } else {
      el.removeAttribute('title');
    }
  };

  return (
    <span style={style} onMouseEnter={handleMouseEnter}>
      {text}
    </span>
  );
}
